import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconActivityLog, IconApp, IconList } from '../../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../../shared/audit/use-audit-capabilities'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuItem, MenuRecycle } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListApp } from '../../../../../../api-new/state/config'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'

export const AppList = () => {
  const apiListApp = useApiListApp()

  const roleSysApp = useRoleSysApp()
  const caps = useAuditCapabilities()

  const handleReady = () => apiListApp.get()
  const handleDestroyed = () => apiListApp.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" to="/admin/app/add" show={roleSysApp.accessCreate} />
      <MenuRecycle to="/admin/app/recycle" show={roleSysApp.accessDelete} />
      <MenuItem Icon={IconActivityLog} text="audit log" to="/admin/audit-log?type=apps" show={caps.sysAuditLog} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconApp} text="Apps">
        <CardFullHeightScrollY title="apps" HeaderMenu={HeaderMenu}>
          <TableAgClient
            apiList={apiListApp}
            onReady={handleReady}
            onDestoryed={handleDestroyed}
            emptyState={{
              Icon: IconApp,
              title: 'No apps yet',
              message: 'Apps you add appear here, with their store listings and versions.',
              action: { label: 'Add app', to: '/admin/app/add', show: roleSysApp.accessCreate }
            }}>
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/admin/app/edit/${row.id}`} show={roleSysApp.accessUpdate} />
                  <MenuItem Icon={IconList} text="stores" to={`/admin/app/edit/${row.id}/store`} show pin />
                  <MenuDelete to={`/admin/app/edit/${row.id}/delete`} show={roleSysApp.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
